import { render, staticRenderFns } from "./TmntClubsStat.vue?vue&type=template&id=b5bedfd6&"
import script from "./TmntClubsStat.vue?vue&type=script&lang=js&"
export * from "./TmntClubsStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports